/**
 * FASWORLD filter bar — facet accordion + price sanitize
 */
(() => {
  if (window.__fwFilterbarBound) return;
  window.__fwFilterbarBound = true;

  const sanitizeMoney = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const normalized = raw.replace(/[^\d.,]/g, '');
    if (normalized.includes(',') && normalized.includes('.')) {
      return normalized.replace(/,/g, '');
    }
    if (normalized.includes(',')) {
      const parts = normalized.split(',');
      if (parts.length === 2 && parts[1].length <= 2) {
        return `${parts[0].replace(/\./g, '')}.${parts[1]}`;
      }
      return normalized.replace(/,/g, '');
    }
    return normalized;
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLDetailsElement)) return;
      if (!target.classList.contains('fw-filterbar__facet') || !target.open) return;

      const bar = target.closest('[data-fw-filterbar]');
      if (!bar) return;

      bar.querySelectorAll('details.fw-filterbar__facet[open]').forEach((el) => {
        if (el !== target) el.open = false;
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('[data-fw-filterbar]')) return;

      form.querySelectorAll('.fw-filterbar__price input[name]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.value = sanitizeMoney(input.value);
      });
    },
    true
  );
})();
